import request from '@/utils/request'
//获取分销商
export function getDistributorList (params) {
  return request({
    url: '/dmcht/list',
    method: 'get',
    params: params
  })
}
//分销商邀请
export function createInvitation (data) {
  return request({
    url: '/dmcht/invitation',
    method: 'put',
    data: data
  });
}
//审核操作/终止
export function auditDistributor (params) {
  return request({
    url: '/dmcht/audit',
    method: 'put',
    params: params
  });
}
//邀约撤销/删除
export function undoDistributor (params) {
  return request({
    url: '/dmcht/undo',
    method: 'delete',
    params: params
  });
}

//获取分销商等级列表(报价管理)
export function getQuotationList (params) {
  return request({
    url: '/dmcht/level/list',
    method: 'get',
    params: params
  })
}
//获取分销商等级折扣
export function getLevelDiscount (params) {
  return request({
    url: '/dmcht/level/get',
    method: 'get',
    params: params
  })
}
//设置分销商等级折扣(设置报价)
export function setQuotation (data) {
  return request({
    url: '/dmcht/level/set',
    method: 'put',
    data: data
  });
}


// WEBPACK FOOTER //
// ./src/api/distributorManagement.js